import { isPlatformBrowser } from '@angular/common';
import { DestroyRef, Inject, Injectable, PLATFORM_ID, inject } from '@angular/core';
import { AuthGuardService } from './auth-guard.service';

import { DynamicScriptLoaderService } from './dynamicScriptLoader.service';
import { PartnerService } from './partner.service';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
declare var htmlToPdfmake;
declare var pdfMake;

const logo = `<?xml version="1.0" encoding="UTF-8"?>
<!DOCTYPE svg PUBLIC "-//W3C//DTD SVG 1.1//EN" "http://www.w3.org/Graphics/SVG/1.1/DTD/svg11.dtd">
<!-- Creator: CorelDRAW 2021 (64-Bit) -->
<svg xmlns="http://www.w3.org/2000/svg" xml:space="preserve" width="100%" height="100%" version="1.1" style="shape-rendering:geometricPrecision; text-rendering:geometricPrecision; image-rendering:optimizeQuality; fill-rule:evenodd; clip-rule:evenodd"
viewBox="0 0 17000 4000"
 xmlns:xlink="http://www.w3.org/1999/xlink"
 xmlns:xodm="http://www.corel.com/coreldraw/odm/2003">
 <defs>
  <style type="text/css">
   <![CDATA[
    .str0 {stroke:#545454;stroke-width:20;stroke-miterlimit:22.9256}
    .fil0 {fill:#545454;fill-rule:nonzero}
    .fil1 {fill:var(--cl-bg-color);fill-rule:nonzero}
   ]]>
  </style>
 </defs>
 <g id="Ebene_x0020_1">
  <metadata id="CorelCorpID_0Corel-Layer"/>
  <g id="_1674900038576">
   <path class="fil0 str0" d="M7716.89 1484.35l0 188.74 -176.81 0 0 -188.74 176.81 0zm-6651.21 -673c-42.07,-8.58 -333.74,-12.79 -427.1,-12.79 -119.43,0 -195.26,8.74 -227.47,26.21 -32.23,17.48 -48.34,59.08 -48.34,125.49 0,100.31 54.23,152.75 162.27,157.63l130.43 6.3 164.63 6.99c199.58,9.09 299.37,101.72 299.37,278.58 0,110.1 -33,185.6 -99.01,226.5 -66,40.89 -187,61.51 -362.63,61.51 -75.56,0 -408.65,-3.43 -464.48,-10.28l0 -122.77c40.07,8.97 362.38,13.51 432.27,13.51 132.79,0 219.62,-11.18 261.66,-33.9 41.64,-22.37 62.47,-69.56 62.47,-141.21 0,-103.11 -52.65,-154.85 -157.95,-154.85 -244.76,0 -405.85,-18.52 -482.84,-55.22 -77.4,-37.06 -115.91,-113.26 -115.91,-229.65 0,-109.75 30.65,-183.16 91.55,-219.51 60.88,-36.7 182.29,-54.87 364.2,-54.87 73.63,0 361.84,4.98 416.88,14.94l0 117.39zm1182.16 -117.65l0 979.39 -160.3 0 11.4 -127.93 -3.54 -3.14c-55.79,97.17 -176.01,145.75 -359.49,145.75 -257.33,0 -386.2,-114.29 -386.2,-342.54l0 -651.53 160.29 0 0 651.53c0,88.78 16.5,147.86 49.5,177.91 33.4,30.06 98.22,45.09 195.27,45.09 127.29,0 214.51,-22.37 261.66,-67.11 47.54,-44.73 71.11,-126.53 71.11,-246.07l0 -561.35 160.3 0zm297.8 0l154.4 0 -4.31 133.17 4.31 3.15c49.5,-100.67 171.3,-151 366.57,-151 157.55,0 264.01,24.47 319.41,73.75 55.79,49.29 83.69,143.66 83.69,283.12l0 637.2 -160.3 0 0 -624.96 0 -36.71c0,-83.88 -18.07,-140.51 -54.22,-169.52 -36.14,-29.01 -105.69,-43.34 -209.01,-43.34 -226.7,0 -340.24,95.07 -340.24,285.57l0 588.96 -160.3 0 0 -979.39zm1800.2 0l0 119.54 -424.31 0 0 598.06c0,104.5 52.25,156.93 156.75,156.93 103.72,0 155.58,-46.84 155.58,-140.51l1.18 -48.24 2.36 -54.52 149.69 0 1.18 73.05c0,193.29 -102.94,289.76 -308.41,289.76 -212.56,0 -318.64,-80.39 -318.64,-241.52l0 -34.95 0 -598.06 -153.22 0 0 -119.54 153.22 0 0 -234.89 160.31 0 0 234.89 424.31 0zm637.64 -14.68c202.73,0 334.74,31.45 395.25,94.37 60.51,62.92 90.76,199.59 90.76,410.01 0,210.42 -30.25,347.08 -90.76,410 -60.51,62.92 -192.52,94.37 -395.25,94.37 -202.33,0 -333.94,-31.45 -394.45,-94.37 -60.51,-62.92 -90.76,-199.58 -90.76,-410 0,-210.42 30.25,-347.09 90.76,-410.01 60.51,-62.92 192.12,-94.37 394.45,-94.37zm0 119.54c-142.21,0 -230.62,20.62 -264.4,61.87 -34.18,41.24 -51.08,148.9 -51.08,322.97 0,174.06 16.9,281.72 51.08,322.97 33.78,41.24 122.19,61.86 264.4,61.86 142.62,0 231.42,-20.62 265.2,-61.86 34.18,-41.25 51.08,-148.91 51.08,-322.97 0,-174.07 -16.9,-281.73 -51.08,-322.97 -33.78,-41.25 -122.58,-61.87 -265.2,-61.87zm1635.98 -104.86l0 979.39 -160.3 0 11.4 -127.93 -3.54 -3.14c-55.79,97.17 -176.01,145.75 -359.49,145.75 -257.33,0 -386.21,-114.29 -386.21,-342.54l0 -651.53 160.3 0 0 651.53c0,88.78 16.5,147.86 49.5,177.91 33.4,30.06 98.22,45.09 195.27,45.09 127.29,0 214.51,-22.37 261.66,-67.11 47.54,-44.73 71.11,-126.53 71.11,-246.07l0 -561.35 160.3 0zm314.3 0l160.29 0 -16.1 112.55 3.54 2.8c63.64,-92.28 168.54,-138.42 315.09,-138.42 202.34,0 303.31,92.98 303.31,278.58l-0.4 67.46 -158.72 0 2.74 -24.47c1.97,-25.87 3.15,-43.34 3.15,-52.08 0,-99.97 -61.28,-149.95 -183.87,-149.95 -179.16,0 -268.74,98.57 -268.74,295.36l0 587.56 -160.29 0 0 -979.39zm4459.95 117.65c-42.08,-8.58 -333.75,-12.79 -427.11,-12.79 -119.43,0 -195.26,8.74 -227.47,26.21 -32.23,17.48 -48.33,59.08 -48.33,125.49 0,100.31 54.22,152.75 162.26,157.63l130.43 6.3 164.63 6.99c199.58,9.09 299.37,101.72 299.37,278.58 0,110.1 -33,185.6 -99,226.5 -66.01,40.89 -187.01,61.51 -362.63,61.51 -75.57,0 -408.66,-3.43 -464.49,-10.28l0 -122.77c40.07,8.97 362.38,13.51 432.27,13.51 132.79,0 219.62,-11.18 261.66,-33.9 41.65,-22.37 62.47,-69.56 62.47,-141.21 0,-103.11 -52.65,-154.85 -157.95,-154.85 -244.76,0 -405.84,-18.52 -482.84,-55.22 -77.4,-37.06 -115.91,-113.26 -115.91,-229.65 0,-109.75 30.65,-183.16 91.55,-219.51 60.89,-36.7 182.29,-54.87 364.2,-54.87 73.63,0 361.84,4.98 416.89,14.94l0 117.39zm-3376.66 -117.65l160.3 0 -16.11 112.55 3.53 2.8c63.65,-92.28 168.56,-138.42 315.09,-138.42 202.35,0 303.31,92.98 303.31,278.58l-0.39 67.46 -158.73 0 2.75 -24.47c1.97,-25.87 3.15,-43.34 3.15,-52.08 0,-99.97 -61.29,-149.95 -183.87,-149.95 -179.16,0 -268.73,98.57 -268.73,295.36l0 587.56 -160.3 0 0 -979.39zm1688.62 683.69l164.62 0 0.78 36c0,101.72 -34.57,172.67 -104.11,213.57 -69.54,40.54 -191.73,60.81 -365.77,60.81 -202.73,0 -335.92,-32.85 -399.18,-98.91 -63.25,-66.07 -95.08,-204.48 -95.08,-415.6 0,-195.74 31.83,-326.82 95.47,-393.93 64.05,-66.75 188.59,-100.31 374.43,-100.31 203.11,0 335.91,29.01 398.77,87.03 62.86,58.03 94.69,180.36 94.69,366.66l0 76.91 -792.06 0c0,154.49 18.47,252.71 55.8,295 37.31,42.29 124.14,63.61 260.86,63.61 129.66,0 213.74,-10.13 252.63,-30.05 38.5,-20.28 58.15,-63.62 58.15,-130.03l0 -30.76zm0 -278.93l-1.18 -46.14c0,-105.56 -19.64,-174.41 -58.93,-206.23 -38.9,-31.8 -123.37,-47.53 -253.02,-47.53 -130.44,0 -215.3,18.52 -253.8,55.93 -38.89,37.04 -58.15,118.49 -58.15,243.97l625.08 0zm579.11 -824.2l0 161.48 -160.3 0 0 -161.48 160.3 0zm0 419.44l0 979.39 -160.3 0 0 -979.39 160.3 0zm2165.19 683.69l164.62 0 0.78 36c0,101.72 -34.57,172.67 -104.11,213.57 -69.54,40.54 -191.73,60.81 -365.77,60.81 -202.73,0 -335.92,-32.85 -399.18,-98.91 -63.25,-66.07 -95.08,-204.48 -95.08,-415.6 0,-195.74 31.83,-326.82 95.47,-393.93 64.05,-66.75 188.58,-100.31 374.42,-100.31 203.12,0 335.92,29.01 398.78,87.03 62.86,58.03 94.69,180.36 94.69,366.66l0 76.91 -792.06 0c0,154.49 18.47,252.71 55.8,295 37.31,42.29 124.14,63.61 260.86,63.61 129.66,0 213.74,-10.13 252.63,-30.05 38.5,-20.28 58.15,-63.62 58.15,-130.03l0 -30.76zm0 -278.93l-1.18 -46.14c0,-105.56 -19.64,-174.41 -58.93,-206.23 -38.9,-31.8 -123.37,-47.53 -253.03,-47.53 -130.43,0 -215.29,18.52 -253.79,55.93 -38.89,37.04 -58.15,118.49 -58.15,243.97l625.08 0zm418.82 -404.76l154.4 0 -4.32 133.17 4.32 3.15c49.5,-100.67 171.29,-151 366.56,-151 157.55,0 264.02,24.47 319.41,73.75 55.8,49.29 83.69,143.66 83.69,283.12l0 637.2 -160.3 0 0 -624.96 0 -36.71c0,-83.88 -18.07,-140.51 -54.22,-169.52 -36.14,-29.01 -105.69,-43.34 -209.01,-43.34 -226.69,0 -340.24,95.07 -340.24,285.57l0 588.96 -160.29 0 0 -979.39z"/>
   <path class="fil1" d="M16801.32 544.78c0,0 -36.2,-18.1 -104.58,12.07 -68.39,30.18 -197.11,84.47 -245.37,132.75 -78.44,76.43 -223.24,191.06 -355.98,321.79l-287.6 -56.31 58.32 -56.31c20.11,-20.11 20.11,-52.29 0,-74.42 -20.11,-20.11 -52.29,-20.11 -74.41,0l-108.61 106.6 -162.9 -32.18 46.25 -46.26c20.11,-20.11 20.11,-52.29 0,-74.41 -20.11,-22.13 -52.29,-20.11 -74.41,0l-98.55 96.53 -687.83 -132.74 -110.62 110.62 816.55 414.31 187.04 187.03 -251.39 325.82 -199.11 245.37 -547.06 -100.57c-24.13,-4.02 -50.28,4.03 -66.36,20.11l0 0c-36.21,34.19 -28.16,94.53 14.07,120.67l339.9 201.13c-400.23,372.08 -862.81,673.75 -1365.61,892.97 -293.64,126.7 -599.34,227.27 -911.07,295.65l-235.32 46.26c-78.43,12.07 -158.88,24.13 -237.32,34.18 -80.44,8.05 -158.88,18.11 -239.33,24.14l-241.34 8.04c-319.78,4.03 -641.58,-14.07 -959.35,-62.35 -317.77,-48.26 -631.52,-126.7 -935.22,-235.31 -607.39,-217.21 -1176.55,-557.11 -1655.23,-1001.58 454.53,470.62 1011.64,842.7 1621.04,1092.09 303.69,126.7 621.46,221.23 947.28,285.59 323.8,66.37 655.65,96.54 987.5,92.52l249.39 -12.07c82.46,-4.03 164.92,-12.07 247.38,-20.11 82.46,-8.05 164.92,-20.11 247.38,-30.18l245.37 -42.23c325.82,-64.36 645.6,-160.9 953.32,-287.6 530.96,-217.21 1025.71,-526.94 1454.1,-911.07l195.09 337.88c24.13,44.25 84.46,52.29 120.67,16.08l-0.01 0.01c18.1,-18.1 26.15,-42.23 22.12,-66.37l-92.51 -549.06 247.38 -195.08 327.83 -247.38 185.03 187.04 404.25 822.59 110.62 -110.62 -120.67 -669.73 106.59 -104.59c20.11,-20.11 20.11,-52.29 0,-74.41 -20.11,-22.13 -52.29,-20.11 -74.41,0l-56.31 54.3 -30.17 -162.9 116.64 -114.64c20.11,-20.11 20.11,-52.29 0,-74.42 -20.11,-20.11 -52.29,-20.11 -74.41,0l-66.37 64.36 -56.31 -309.72c132.74,-130.73 249.39,-275.54 325.82,-351.96 50.28,-48.27 104.59,-176.99 136.76,-243.36 28.14,-62.35 12.05,-98.56 12.05,-98.56z"/>
  </g>
 </g>
</svg>
`;

@Injectable({
    providedIn: 'root',
})
export class ExportService {
    doc: any;
    destroyRef = inject(DestroyRef);
    constructor(
        @Inject(PLATFORM_ID) private platformId: any,
        private authService: AuthGuardService,
        protected partnerService: PartnerService,
        private dynamicScriptLoader: DynamicScriptLoaderService
    ) { }

    async createContentPDF(title, res, saving) {
        this.dynamicScriptLoader.load('html-to-pdfmake').then(data => {
            try {
                if (res && res.length > 0) {
                    const content = [];
                    for (let i = 0; i < res.length; i++) {
                        if (res[i].additionalContent) {
                            content.push(
                                {
                                    table: {
                                        widths: ['100%'],
                                        body: [
                                            [
                                                {
                                                    alignment: 'center',
                                                    text: htmlToPdfmake(res[i].additionalContent.replace(new RegExp('\\r?\\n', 'g'), '<br />')),
                                                    border: [false, true, false, true],
                                                    margin: 10,
                                                    padding: 0.8
                                                }
                                            ]
                                        ]
                                    },
                                    // layout: 'noBorders'
                                },
                            );
                        }
                        content.push(
                            {
                                text: htmlToPdfmake(res[i].headline ? res[i].headline.replace(new RegExp('\\r?\\n', 'g'), '<br />') : ''),
                                fontSize: 12,
                                bold: true,
                                margin: [0, 0, 0, 10],
                                padding: 0.2
                            },
                            {
                                text: htmlToPdfmake(res[i].content ? res[i].content.replace(new RegExp('\\r?\\n', 'g'), '<br />') : ''),
                                fontSize: 10,
                                bold: false,
                                margin: [0, 0, 0, 10],
                                padding: 0.2
                            },
                        );
                    }
                    const dd = {
                        pageSize: 'A4',
                        font: 'Helvetica',
                        pageOrientation: 'portrait',
                        pageMargins: [40, 80, 40, 40],
                        header: {
                            margin: 20,
                            style: 'header',
                            columns: [
                                {
                                    table: {
                                        widths: ['100%'],
                                        body: [
                                            [
                                                {
                                                    text: title.toUpperCase(),
                                                    margin: [0, 10],
                                                    border: [false, false, false, false],
                                                },
                                            ]
                                        ]
                                    },
                                    // layout: 'noBorders'
                                }
                            ]
                        },
                        content: content,
                        footer: (currentPage, pageCount) => {
                            return {
                                style: 'footer',
                                columns: [
                                    {
                                        table: {
                                            widths: ['100%'],
                                            body: [
                                                [
                                                    {
                                                        alignment: 'center',
                                                        text: currentPage.toString() + ' von ' + pageCount,
                                                        border: [false, false, false, false],
                                                    }
                                                ]
                                            ]
                                        },
                                        // layout: 'noBorders'
                                    }
                                ]
                            };
                        },
                        styles: {
                            header: {
                                fontSize: 18,
                                bold: true
                            },
                            footer: {
                                margin: [10, 0],
                                fontSize: 9
                            },
                            table: {
                                margin: [40, 0, 10, 60],
                                fontSize: 10,
                            },
                            tableHeader: {
                                bold: true,
                                fontSize: 10,
                                color: 'white'
                            }
                        }
                    };
                    if (isPlatformBrowser(this.platformId)) {
                        this.dynamicScriptLoader.load('pdfMake').then(_ => {
                            this.dynamicScriptLoader.load('vfs_fonts').then(_ => {
                                if (saving === true) {
                                    pdfMake?.createPdf(dd)?.download(title + '.pdf');
                                } else {
                                    pdfMake?.createPdf(dd)?.open();
                                }
                            }).catch(error => console.log(error));
                        }).catch(error => console.log(error));
                    }
                }
            } catch (e) {
                console.log(e);
            }
        }).catch(error => console.log(error));
    }

    urlToBase64(url: string): Promise<any> {
        return new Promise((resolve, reject) => {
            // eslint-disable-next-line no-undef
            const img = new Image();
            img.crossOrigin = 'Anonymous';
            img.src = url;
            img.onload = () => {
                const canvas = document.createElement('canvas');
                const ctx = canvas.getContext('2d');
                canvas.height = img.height;
                canvas.width = img.width;
                ctx.fillStyle = '#FFF';
                ctx.fillRect(0, 0, canvas.width, canvas.height);
                ctx.drawImage(img, 0, 0);
                resolve(canvas.toDataURL('image/jpeg'));
            };
            img.onerror = error => { console.log(error); reject(error) };
        });
    }

    async exportOffers(header) {
        const imgg = [];
        if (this.authService.getlogo()) {
            this.partnerService.request({ url: 'https://' + document.location.hostname + '/logo/' + this.authService.getPartnerId() + '/' + this.authService.getlogo() }, 'getlogo').pipe(
                takeUntilDestroyed(this.destroyRef)
            ).subscribe(async mylogo => {
                if(mylogo?.logo?.length > 0) {
                    const tmplogo = await this.urlToBase64(mylogo.logo);
                    imgg.push([
                        {
                            // you can also fit the svg inside a rectangle
                            image: tmplogo,
                            width: 70
                        }
                    ]);
                } else {
                    imgg.push([
                        {
                            // you can also fit the svg inside a rectangle
                            svg: logo,
                            fit: [150, 100]
                        }
                    ]);
                }
                this.exportOffersPdf(header, imgg);
            });
        } else {
            imgg.push([
                {
                    // you can also fit the svg inside a rectangle
                    svg: logo,
                    fit: [150, 100]
                }
            ]);
            this.exportOffersPdf(header, imgg);
        }
    }

    // imgg.push([
    //     {
    //         // you can also fit the svg inside a rectangle
    //         svg: logo,
    //         fit: [150, 100]
    //     }
    // ])

    async exportOffersPdf(header, imgg) {
        const dd = {
            pageSize: 'A4',
            font: 'Helvetica',
            pageOrientation: 'portrait',
            pageMargins: [40, 80, 40, 40],
            header: {
                margin: 20,
                style: 'header',
                columns: [
                    {
                        table: {
                            widths: ['100%'],
                            body: [
                                [
                                    {
                                        alignment: 'center',
                                        stack: imgg,
                                        border: [false, false, false, false],
                                    }
                                ]
                            ]
                        },
                        // layout: 'noBorders'
                    }
                ]
            },
            watermark: { text: window.location.host, color: 'gray', opacity: 0.1, bold: true, italics: false, /* angle: 0 */ },
            content: header,
            footer: (currentPage, pageCount) => {
                return {
                    style: 'footer',
                    columns: [
                        {
                            table: {
                                widths: ['100%'],
                                body: [
                                    [
                                        {
                                            alignment: 'center',
                                            text: currentPage.toString() + ' von ' + pageCount,
                                            border: [false, false, false, false],
                                        }
                                    ]
                                ]
                            },
                            // layout: 'noBorders'
                        }
                    ]
                };
            },
            styles: {
                header: {
                    fontSize: 18,
                    bold: true
                },
                footer: {
                    margin: [10, 0],
                    fontSize: 9
                },
                table: {
                    margin: [40, 0, 10, 60],
                    fontSize: 10,
                },
                tableHeader: {
                    bold: true,
                    fontSize: 10,
                    color: 'white'
                },
                offerheader: {
                    fontSize: 14,
                    bold: true,
                }
            }
        };
        if (isPlatformBrowser(this.platformId)) {
            this.dynamicScriptLoader.load('pdfMake').then(_ => {
                this.dynamicScriptLoader.load('vfs_fonts').then(_ => {
                    pdfMake?.createPdf(dd)?.open();
                }).catch(error => console.log(error));
            }).catch(error => console.log(error));
        }
    }

    async exportReisekompass(content) {
        const imgg = [];
        if (this.authService.getlogo()) {
            this.partnerService.request({ url: 'https://' + document.location.hostname + '/logo/' + this.authService.getPartnerId() + '/' + this.authService.getlogo() }, 'getlogo').pipe(
                takeUntilDestroyed(this.destroyRef)
            ).subscribe(async mylogo => {
                if(mylogo?.logo?.length > 0) {
                    const tmplogo = await this.urlToBase64(mylogo.logo);
                    imgg.push([
                        {
                            // you can also fit the svg inside a rectangle
                            image: tmplogo,
                            width: 70
                        }
                    ]);
                } else {
                    imgg.push([
                        {
                            // you can also fit the svg inside a rectangle
                            svg: logo,
                            fit: [150, 100]
                        }
                    ]);
                }
                this.exportReisekompassPdf(content, imgg);
            });
        } else {
            imgg.push([
                {
                    // you can also fit the svg inside a rectangle
                    svg: logo,
                    fit: [150, 100]
                }
            ]);
            this.exportReisekompassPdf(content, imgg);
        }
    }

    async exportReisekompassPdf(content, imgg) {
        const dd = {
            pageSize: 'A4',
            font: 'Helvetica',
            pageOrientation: 'portrait',
            pageMargins: [40, 80, 40, 40],
            header: {
                margin: 20,
                style: 'header',
                columns: [
                    {
                        table: {
                            widths: ['100%'],
                            body: [
                                [
                                    {
                                        stack: imgg,
                                        border: [false, false, false, false],
                                    }
                                ]
                            ]
                        },
                        // layout: 'noBorders'
                    }
                ]
            },
            content: content,
            footer: (currentPage, pageCount) => {
                return {
                    style: 'footer',
                    columns: [
                        {
                            table: {
                                widths: ['100%'],
                                body: [
                                    [
                                        {
                                            alignment: 'center',
                                            text: currentPage.toString() + ' von ' + pageCount,
                                            border: [false, false, false, false],
                                        }
                                    ]
                                ]
                            },
                            // layout: 'noBorders'
                        }
                    ]
                };
            },
            styles: {
                header: {
                    fontSize: 18,
                    bold: true
                },
                footer: {
                    margin: [10, 0],
                    fontSize: 9
                },
                table: {
                    margin: [40, 0, 10, 60],
                    fontSize: 10,
                },
                tableHeader: {
                    bold: true,
                    fontSize: 10,
                    color: 'white'
                },
                offerheader: {
                    fontSize: 14,
                    bold: true,
                },
            }
        };
        if (isPlatformBrowser(this.platformId)) {
            this.dynamicScriptLoader.load('pdfMake').then(_ => {
                this.dynamicScriptLoader.load('vfs_fonts').then(_ => {
                    pdfMake?.createPdf(dd)?.open();
                }).catch(error => console.log(error));
            }).catch(error => console.log(error));
        }
    }
}
